jQuery(document).ready(function($){
	
	var navigationSections = $('.scrollnavigation-section'),
		navigationItems = $('#scrollnavigation a');

    if ($('#scrollnavigation').length) {
        
        updateNavigation();

        var scroll = function () {

            // Active Status Navi
            updateNavigation()

            // Fade In Navi
            if ($(window).width() > 1399) {
                if ($('.onpagenavigation').offset().top - $(window).height() / 2 < $(window).scrollTop()) {
                    $('#scrollnavigation').fadeIn();
                }

                if ($('.onpagenavigation').offset().top - $(window).height() / 2 > $(window).scrollTop()) {
                    $('#scrollnavigation').fadeOut();
                    navigationItems.removeClass('is-selected');
                }
            } else {
                $('#scrollnavigation').hide();
            }

            $(window).resize(function () {
                if ($(window).width() > 1399) {
                    // Fade In Navi
                    if ($('.onpagenavigation').offset().top - $(window).height() / 2 < $(window).scrollTop()) {
                        $('#scrollnavigation').fadeIn();
                    }

                    if ($('.onpagenavigation').offset().top - $(window).height() / 2 > $(window).scrollTop()) {
                        $('#scrollnavigation').fadeOut();
                        navigationItems.removeClass('is-selected');
                    }
                } else {
                    $('#scrollnavigation').hide();
                }
            });

        };
        var waiting = false;

        $(window).scroll(function () {
            if (waiting) {
                return;
            }
            waiting = true;

            scroll();

            setTimeout(function () {
                waiting = false;
            }, 100);
        });

    }


	function updateNavigation() {
		navigationSections.each(function(){			 
			if (  $(this).offset().top - $(window).height()/2 < $(window).scrollTop() ) {
                navigationItems.removeClass('is-selected');
                navigationItems.filter('a[data-section="'+$(this).attr('id')+'"]').addClass('is-selected');
            }  
        });        
	}	

});


// WEBPACK FOOTER //
// ./js/parts/scrollnavigation.js